import { createContext, useContext } from 'react'

export type IndexName = string & { _protect: '' }

export type WidgetConfig = {
  appId: string
  apiKey: string
  baseUrl: string
  postsPerPage: number
  indexName: IndexName
  contactUrl: string
  icons: Record<string, string>
  imgixSrcUrl: string
  imgixTargetUrl: string
  locale: string
}

const ConfigContext = createContext<WidgetConfig>({
  appId: '',
  apiKey: '',
  baseUrl: '',
  postsPerPage: 10,
  indexName: 'sermons' as IndexName,
  contactUrl: '',
  icons: {},
  imgixSrcUrl: '',
  imgixTargetUrl: '',
  locale: ''
})

export function useConfigContext() {
  return useContext(ConfigContext)
}

export const ConfigProvider = ConfigContext.Provider
